import React, { useCallback, useContext, useEffect } from 'react';
import classnames from 'classnames';
import { useTranslation } from 'react-i18next';
import SubfoldersIcon from '@wix/da-ds/pkg/Icons/24x24/Subfolders';
import { DropdownStateContext } from '@wix/da-ds/pkg/Dropdown/DropdownStateManager/DropdownStateContext';
import StandardMenu from '@wix/da-ds/pkg/Dropdown/MenuPreset/StandardMenu';
import { gallectionTypeToResourceType } from '../../types/gallection';
import FolderThumb from './FolderThumb';
import { BiContextProvidedValue, BiData } from '@wix/da-bi/pkg/events';
import shortenNumber from '../../utils/shortenNumber';
import { CheckIcon } from 'wix-rich-content-ui-components';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import PremiumFolderDataIcon from '../_partials/PremiumFolderDataIcon/PremiumFolderDataIcon';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import folderDropdownDesktopStyles from './FolderDropdownDesktop.scss';
const hasSubFolders = (folder)=>folder.hasSubfolders || folder.subfolders && folder.subfolders.length > 0;
const FolderDropdownDesktopMenu = ({ id, isOpen: forceOpen, className, folders, currentFolder, hasMore, setSelectedFolderId, fetchMore })=>{
    const { isOpen, closeDropdown } = useContext(DropdownStateContext);
    const isMobile = useContext(MobileContext);
    const selectFolder = useCallback((folderId)=>{
        setSelectedFolderId(folderId);
        closeDropdown();
    }, [
        setSelectedFolderId,
        closeDropdown
    ]);
    const { t } = useTranslation();
    useEffect(()=>{
        if ((isOpen || forceOpen) && hasMore && fetchMore) {
            fetchMore();
        }
    }, [
        isOpen,
        forceOpen,
        hasMore,
        fetchMore
    ]);
    if (!(isOpen || forceOpen)) {
        return null;
    }
    const menuItems = folders.map((folder, index)=>{
        var _folder_totalItemCount, _folder_totalItemCount1;
        return {
            label: /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(PremiumFolderDataIcon, {
                premiumFolderData: folder === null || folder === void 0 ? void 0 : folder.premiumFolderData,
                size: IconSize.SMALLER,
                className: folderDropdownDesktopStyles['premium-folder-icon']
            }), folder.name, hasSubFolders(folder) && /*#__PURE__*/ React.createElement(SubfoldersIcon, {
                size: IconSize.SMALL,
                className: folderDropdownDesktopStyles['updated-subfolders-icon']
            })),
            boldLabel: true,
            subLabel: t('gallectionDropdown.folder.stats.artworks', {
                formattedCount: shortenNumber((_folder_totalItemCount = folder.totalItemCount) !== null && _folder_totalItemCount !== void 0 ? _folder_totalItemCount : folder.size),
                count: (_folder_totalItemCount1 = folder.totalItemCount) !== null && _folder_totalItemCount1 !== void 0 ? _folder_totalItemCount1 : folder.size
            }),
            icon: /*#__PURE__*/ React.createElement(FolderThumb, {
                folder: folder,
                hasSubfolders: false
            }),
            suffix: currentFolder && currentFolder.folderId === folder.folderId && /*#__PURE__*/ React.createElement(CheckIcon, {
                size: IconSize.TINY
            }),
            value: folder.folderId,
            biData: BiData({
                evid: 100,
                rank: index,
                creatorid: folder.owner.useridUuid,
                typeid: gallectionTypeToResourceType(folder.type),
                itemid: folder.folderId,
                page_typeid: BiContextProvidedValue,
                page_itemid: BiContextProvidedValue,
                sectionid: BiContextProvidedValue,
                sectionname: BiContextProvidedValue,
                section_typeid: BiContextProvidedValue,
                sectiontype: BiContextProvidedValue,
                widgetname: BiContextProvidedValue
            })
        };
    });
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        id: id,
        className: classnames(className, !isMobile && folderDropdownDesktopStyles['updated-menu-desktop']),
        items: menuItems,
        onSelect: selectFolder,
        scrollable: !isMobile,
        withCardWrapper: !isMobile
    });
};
FolderDropdownDesktopMenu.displayName = 'FolderDropdownDesktopMenu';
export default FolderDropdownDesktopMenu;

//# sourceMappingURL=FolderDropdownDesktopMenu.js.map